import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MenuItem from './menuItem'
import MenuTree from './menuTree'
import { withRouter } from 'react-router-dom';

import { carregarUsuario } from '../../auth/authActions';

class Menu extends Component {

	state = {
		acessoAberto: null,
		cadastroAberto: null
	}

	constructor(props) {
		super(props);

		let idInterval = setInterval(() => {
			if (this.props.usuario) {
				this.props.carregarUsuario();
				clearInterval(idInterval);
			}
		}, 2000);
	}

	render() {

		const usuarioCarregado = this.props.usuarioCarregado;

		let selecionado = '';
		if (this.props.location && this.props.location.pathname) {
			selecionado = this.props.location.pathname;
		}

		if (selecionado != '/' 
			&& this.state.acessoAberto == null
			&& this.state.cadastroAberto == null
		) {
			if (selecionado == '/usuarioPerfil' || selecionado == '/usuario') {
				this.setState({
					...this.state,
					acessoAberto: true
				});
			} else if (selecionado == '/empresa' || selecionado == '/fornecedor' || selecionado == '/tipoProducao' 
				|| selecionado == '/faseProducao' || selecionado == '/parceiro' || selecionado == '/transportadora'
				|| selecionado == '/motorista' || selecionado == '/veiculo' || selecionado == '/equipamento' 
				|| selecionado == '/materiaPrima' || selecionado == '/materiaPrima' || selecionado == '/unidadeMedida' 
				|| selecionado == '/racao') {
				this.setState({
					...this.state,
					cadastroAberto: true
				});
			}
		}		
		
		return (
			<nav className="mt-2">

				{usuarioCarregado &&			    
				<ul className="nav nav-pills nav-sidebar flex-column nav-flat nav-compact" data-widget="treeview" role="menu" data-accordion="false">
					<MenuItem path='/' label='Dashboard' icon='fas fa-tachometer-alt' active={selecionado == '/'} />
					
					{(this.props.getPermissao('cadastro_perfil') || this.props.getPermissao('cadastro_usuario')) &&
					<MenuTree icon={'fas fa-user-lock'} label={'Acesso'}
						display={this.state.acessoAberto}
						onClick={() =>
							this.setState({
								...this.state,
								acessoAberto: !this.state.acessoAberto,
							})
						} >
						{this.props.getPermissao('cadastro_perfil') &&
						<MenuItem submenu path='usuarioPerfil' label='Perfil' icon='fas fa-list' active={selecionado == '/usuarioPerfil'} />}
						{this.props.getPermissao('cadastro_usuario') &&
						<MenuItem submenu path='usuario' label='Usuário' icon='fas fa-id-card-alt' active={selecionado == '/usuario'} />}
					</MenuTree>}

					{(this.props.getPermissao('cadastro_fornecedor')
						|| this.props.getPermissao('cadastro_tipo_producao')
						|| this.props.getPermissao('cadastro_parceiro')
						|| this.props.getPermissao('cadastro_transportadora')
						|| this.props.getPermissao('cadastro_motorista')
						|| this.props.getPermissao('cadastro_veiculo')
						|| this.props.getPermissao('cadastro_materia_prima')
						|| this.props.getPermissao('cadastro_unidade_medida')
						|| this.props.getPermissao('cadastro_racao')
					) &&
					<MenuTree icon={'fas fa-cogs'} label={'Cadastro'}
						display={this.state.cadastroAberto}
						onClick={() =>
							this.setState({
								...this.state,
								cadastroAberto: !this.state.cadastroAberto,
							})
						} >
						{this.props.getPermissao('cadastro_fornecedor') &&
						<MenuItem submenu path='fornecedor' label='Fornecedor' icon='fas fa-users' active={selecionado == '/fornecedor'} />}
						{this.props.getPermissao('cadastro_tipo_producao') &&
						<MenuItem submenu path='tipoProducao' label='Tipo de Produção' icon='fab fa-github-alt' active={selecionado == '/tipoProducao'} />}
						{this.props.getPermissao('cadastro_fase') &&
						<MenuItem submenu path='faseProducao' label='Fase de Produção' icon='fas fa-list-ol' active={selecionado == '/faseProducao'} />}
						{this.props.getPermissao('cadastro_parceiro') &&
						<MenuItem submenu path='parceiro' label='Parceiro' icon='fas fa-warehouse' active={selecionado == '/parceiro'} />}
						{this.props.getPermissao('cadastro_transportadora') &&
						<MenuItem submenu path='transportadora' label='Transportadora' icon='fas fa-truck-loading' active={selecionado == '/transportadora'} />}
						{this.props.getPermissao('cadastro_motorista') &&
						<MenuItem submenu path='motorista' label='Motorista' icon='fas fa-id-card' active={selecionado == '/motorista'} />}
						{this.props.getPermissao('cadastro_veiculo') &&
						<MenuItem submenu path='veiculo' label='Veículo' icon='fas fa-truck' active={selecionado == '/veiculo'} />}
						{this.props.getPermissao('cadastro_racao') &&
						<MenuItem submenu path='equipamento' label='Equipamento' icon='fas fa-filter' active={selecionado == '/equipamento'} />}
						{this.props.getPermissao('cadastro_materia_prima') &&
						<MenuItem submenu path='materiaPrima' label='Matéria Prima' icon='fas fa-list' active={selecionado == '/materiaPrima'} />}
						{this.props.getPermissao('cadastro_unidade_medida') &&
						<MenuItem submenu path='unidadeMedida' label='Unidade de Medida' icon='fas fa-ruler' active={selecionado == '/unidadeMedida'} />}
						{this.props.getPermissao('cadastro_racao') &&
						<MenuItem submenu path='racao' label='Ração' icon='fas fa-bars' active={selecionado == '/racao'} />}
					</MenuTree>}

					{this.props.getPermissao('solicitacao') &&
					<MenuItem path='solicitacao' label='Solicitação' icon='fas fa-list-ol' active={selecionado == '/solicitacao'} />}

					{this.props.getPermissao('ordem_producao') &&
					<MenuItem path='producaoProgramacao' label='Programar Produção' icon='far fa-calendar' active={selecionado == '/producaoProgramacao'} />}

					{this.props.getPermissao('ordem_producao') &&
					<MenuItem path='producao' label='Produção' icon='far fa-play-circle' active={selecionado == '/producao'} />}

					{this.props.getPermissao('entregas') &&
					<MenuItem path='entrega' label='Entrega' icon='fas fa-truck' active={selecionado == '/entrega'} />}
				</ul>}
			</nav>
		);
	}
}

const mapStateToProps = state => ({
	usuario: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	getPermissao: state.auth.getPermissao
});
const mapDispatchToProps = dispatch => bindActionCreators({ carregarUsuario }, dispatch);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Menu));
